<template>
  <div >
    <el-card class="box-card">
        <img src="@/assets/aboutus.png" width="100%">
    </el-card>
  </div>
</template>

<script>
import img from '@/assets/banner.png'
import {
    wxNativePay
} from '@/api/index.js'
export default {
  name: 'Home',
  data : function(){
    return {
        product : {}
    }
  },
  created() {
      
  },
  methods : {
      
  }
}
</script>

<style>
.product{
    text-align: left;
    line-height: 1.5;
    position: relative;
}
.product .img img{
    width: 100%;
}
.product .title{
    
}
.product .price{
    color: #BD82A6;
}
.product .buy{
    position: absolute;
    right: 0;
    bottom: 0;
    color: #fff;
}
.product .buy span{
    padding: 5px 8px;
    background: #000000;
    border-radius: 2px;
    cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// src/pages/AboutUs.vue